import ms from 'ms'

import arriereBackoffice from '@avantstay/arriere-clients/dist/arriereBackoffice'

import { memoizeIndexedDB } from '../../../FastTapeChart/__utils'

export const getHotelOptions = memoizeIndexedDB(
  'hotelFilterOptions',
  async () => {
    const { list: hotelList } = await arriereBackoffice.queries.hotel({
      __alias: 'getHotelOptions',
      list: {
        hotel: {
          id: true,
          logo: { url: true },
          name: true,
          unitsCount: true,
        },
      },
    })

    const sortedHotelsList = hotelList.toSorted((a, b) => {
      return a.hotel.name.localeCompare(b.hotel.name)
    })

    return sortedHotelsList.map(listItem => ({
      label: listItem.hotel.name,
      value: listItem.hotel.id,
      image: listItem.hotel.logo?.url,
      unitCount: listItem.hotel.unitsCount.toString(),
    }))
  },
  ms('24 hours'),
)
